<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Bell Hill Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Come è possibile nell'era digitale non essere in grado di trovare alcuna informazione su qualcosa? Di
                        evitando attivamente la pubblicità, chiedendo ai giornalisti del vino di non scrivere del tuo incredibile Pinot
                        Noir e Chardonnay (“siamo imbarazzati dalla domanda che crea una buona recensione”), esportando a
                        almeno il 65% del tuo prodotto e assegnando il resto su una base molto rigorosa. Ecco come. Quindi se
                        stai cercando di aggiungere un caso o due di Bell Hill al tuo portafoglio, dovrai cercare
                        molto difficile.
                    </div>

                    <div class="howto-title2">Un modello di Borgogna nel Passo Weka</div>
                    <div class="howto-text">
                        Guadagnando rapidamente lo status di nuovo (quasi) vigneto che vale la pena conoscere, i vigneti di Bell Hill sono una delle storie di successo più segrete di North Canterbury (nell'Isola del Sud della Nuova Zelanda). Un minuscolo vigneto di soli 2 ettari, non saresti solo se non ne avessi mai sentito parlare. Piantato dentro
                        1997 in terreno di prima qualità calcareo calcareo e argilloso calcareo, Chardonnay e Pinot Nero di Bell Hill
                        non sono solo buoni. Loro sono. Molto. Bene. Modellato sull'ethos borgognone dell'alta densità
                        piantagione, "coltivatori" (non proprietari, gestori o produttori di vino) Sherwyn Veldhuizen e Marcel Giesen
                        riporre un'enorme quantità di fiducia nella teoria (non scientifica) che l'eccellente Pinot e
                        Le viti di Chardonnay hanno bisogno di calcare per prosperare. "Abbiamo una grande fiducia nel suolo", afferma
                        Sherwyn. “Con l'età della vite, i nostri vini stanno sviluppando un carattere minerale calcareo più pronunciato.
                        Il terreno dà ai nostri vini forma, tensione e lunghezza. Stiamo ancora imparando e ci sforziamo di ottenere a
                        piccola qualità in più ogni anno.” Detto fatto, come lo sono le colonne sonore di Bell Hill
                        anno dopo anno stratosferico.
                    </div>

                    <div class="howto-title2">Probabilmente uno dei migliori vini neozelandesi sul mercato</div>
                    <div class="howto-text">
                        Purtroppo però questi non sono vini facili da ottenere e la classica equazione della scarsità più
                        qualità significa che Bell Hill è una delle cantine neozelandesi più costose che ci siano. Se tu
                        puoi aggiungere una bottiglia alla tua cantina, il nostro consiglio è di farlo, non solo i vini sono ottimi, ma
                        Il ROI è molto buono; 25% da dicembre 2017 ad aprile 2019. Con una qualità così superlativa, noi
                        credo che Bell Hill non sarà in grado di mantenere il segreto ancora per molto.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Bell Hill Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Wie ist es im digitalen Zeitalter möglich, dass man zu etwas keine Informationen mehr findet? Von
                        Wir meiden aktiv die Öffentlichkeit und bitten Weinjournalisten, nicht über Ihren unglaublichen Pinot zu schreiben
                        Noir und Chardonnay („Uns ist die Nachfrage, die eine gute Rezension hervorruft, peinlich“), indem wir bei exportieren
                        Mindestens 65 % Ihres Produkts und die Zuteilung des Rests erfolgt auf einer sehr strengen Grundlage. So geht das. Also wenn
                        Wenn Sie Ihrem Portfolio ein oder zwei Kisten Bell Hill hinzufügen möchten, müssen Sie nachschauen
                        sehr schwer.
                    </div>

                    <div class="howto-title2">Ein Modell von Burgand im Weka-Pass</div>
                    <div class="howto-text">
                        Bell Hill Vineyards erlangt schnell den Status eines wissenswerten neuen Weinbergs und ist eine der geheimsten Erfolgsgeschichten von North Canterbury (auf der Südinsel Neuseelands). Ein winziger Weinberg von nur 2 Hektar, Sie wären nicht allein, wenn Sie noch nie davon gehört hätten. Eingepflanzt
                        1997 auf erstklassigem kalkhaltigem Kalkstein und kalkhaltigem Lehmboden, Bell Hill’s Chardonnays und Pinot Noirs
                        sind nicht nur gut. Sie sind. Sehr. Gut. Nach dem Vorbild des burgundischen Ethos der hohen Dichte
                        Pflanzen, „Erzeuger“ (keine Eigentümer, Manager oder Winzer) Sherwyn Veldhuizen und Marcel Giesen
                        Ich habe enormes Vertrauen in die (nichtwissenschaftliche) Theorie gesetzt, dass ausgezeichnete Pinot- und
                        Chardonnay-Reben brauchen Kalkstein, um zu gedeihen. „Wir haben großes Vertrauen in den Boden“, sagt er
                        Sherwyn. „Mit zunehmender Rebe entwickeln unsere Weine einen ausgeprägteren Kalkstein-Mineralcharakter.
                        Der Boden verleiht unseren Weinen Form, Spannung und Länge. Wir lernen immer noch und versuchen hart, einen zu erreichen
                        Jedes Jahr etwas mehr Qualität.“ Gesagt, getan, wie die Ergebnisse von Bell Hill zeigen
                        Jahr für Jahr stratosphärisch.
                    </div>

                    <div class="howto-title2">Wahrscheinlich einer der besten neuseeländischen Weine auf dem Markt</div>
                    <div class="howto-text">
                        Leider sind diese Weine nicht leicht zu bekommen und es gilt die klassische Gleichung von Knappheit plus
                        Qualität bedeutet, dass Bell Hill eines der teuersten Weingüter Neuseelands ist. Wenn du
                        Wenn Sie Ihrem Weinkeller eine Flasche hinzufügen können, empfehlen wir Ihnen, dies zu tun. Die Weine sind nicht nur ausgezeichnet, sondern auch
                        Der ROI ist sehr gut; 25 % im Zeitraum Dezember 2017 bis April 2019. Mit solch hervorragender Qualität, wir
                        Ich glaube, Bell Hill wird nicht mehr lange geheim bleiben können.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Bell Hill Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Comment est-il possible à l'ère du numérique de ne pouvoir trouver aucune information sur quelque chose ? Par
                        évitant activement la publicité, demandant aux journalistes du vin de ne pas écrire sur votre incroyable Pinot
                        Noir et Chardonnay ("nous sommes gênés par la demande que crée une bonne revue"), en exportant à
                        moins 65 % de votre produit et en allouant le reste de manière très stricte. C'est comme ça. Donc si
                        vous cherchez à ajouter un cas ou deux de Bell Hill à votre portefeuille, vous allez devoir chercher
                        très dur.
                    </div>

                    <div class="howto-title2">Une maquette de la Bourgogne dans le col du Weka</div>
                    <div class="howto-text">
                        Acquérant rapidement le statut de nouveau (plutôt) vignoble à connaître, les vignobles de Bell Hill sont l'une des réussites les plus secrètes de North Canterbury (dans l'île du Sud de la Nouvelle-Zélande). Un tout petit vignoble de seulement 2 hectares, vous ne seriez pas seul si vous n'en aviez jamais entendu parler. Planté dans
                        1997 dans un sol calcaire crayeux et argilo-calcaire de première qualité, Chardonnays et Pinot Noirs de Bell Hill
                        ne sont pas que bons. Ils sont. Très. Bien. Inspiré de l'esprit bourguignon de la haute densité
                        plantation, « viticulteurs » (ni propriétaires, ni gestionnaires, ni viticulteurs) Sherwyn Veldhuizen et Marcel Giesen
                        faire énormément confiance à la théorie (non scientifique) selon laquelle d'excellents Pinot et
                        Les vignes de Chardonnay ont besoin de calcaire pour s'épanouir. "Nous avons une grande confiance dans le sol", déclare
                        Sherwyn. « Avec l'âge de la vigne, nos vins développent un caractère minéral calcaire plus prononcé.
                        Le sol donne à nos vins forme, tension et longueur. Nous apprenons encore et nous nous efforçons d'acquérir un
                        petit plus de qualité chaque année. Aussitôt dit, aussitôt fait, car les scores de Bell Hill sont
                        stratosphérique année après année.
                    </div>

                    <div class="howto-title2">Probablement l'un des meilleurs vins de Nouvelle-Zélande sur le marché</div>
                    <div class="howto-text">
                        Malheureusement, ce ne sont pas des vins faciles à obtenir et l'équation classique de la rareté plus
                        la qualité signifie que Bell Hill est l'un des vignobles les plus chers de Nouvelle-Zélande. Si tu
                        pouvez ajouter une bouteille à votre cave, notre conseil est de le faire, non seulement les vins sont excellents, mais
                        Le retour sur investissement est très bon; 25% de décembre 2017 à avril 2019. Avec une telle qualité superlative, nous
                        Je pense que Bell Hill ne pourra pas rester secret très longtemps.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Bell Hill Vineyards</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        How is it possible in the digital age to not be able to find any information on something? By
                        actively shunning publicity, asking wine journalists not to write about your incredible Pinot
                        Noir and Chardonnay (“we’re embarrassed by the demand a good review creates”), by exporting at
                        least 65% of your product and by allocating the rest on a very strict basis. That’s how. So if
                        you’re looking to add a case or two of Bell Hill to your portfolio, you’re going to have to look
                        very hard.
                    </div>

                    <div class="howto-title2">A model of Burgandy in the Weka Pass</div>
                    <div class="howto-text">
                        Fast gaining status as a new(ish) vineyard worth knowing about, Bell Hill vineyards is one of North Canterbury (in New Zealand’s South Island) most secret success stories. A teeny-tiny vineyard of just 2-hectacres, you would not be alone if you had never heard of them. Planted in
                        1997 in prime chalky limestone and calcareous clay soil, Bell Hill’s Chardonnays and Pinot Noirs
                        are not just good. They’re. Very. Good. Modelled on the Burgundian ethos of high-density
                        planting, “growers” (not owners, managers nor winemakers) Sherwyn Veldhuizen and Marcel Giesen
                        put an enormous amount of trust in the (non-scientific) theory that excellent Pinot and
                        Chardonnay vines need limestone in order to flourish. “We’ve got great faith in the soil,” says
                        Sherwyn. “With vine age, our wines are developing more pronounced limestone mineral character.
                        The soil gives our wines shape, tension and length. We’re still learning and try hard to gain a
                        little extra quality each year.” No sooner said than done, as Bell Hill’s scores are
                        stratospheric year in year out.
                    </div>

                    <div class="howto-title2">Probably one of the best New Zealand wines on the market</div>
                    <div class="howto-text">
                        Sadly though these are not easy wines to get hold of and the classic equation of scarcity plus
                        quality means that Bell Hill is one of the most expensive New Zealand wineries there is. If you
                        can add a bottle to your cellar, our advice is to do it, not only are the wines excellent, but
                        ROI is very good; 25% in from December 2017 to April 2019. With such superlative quality, we
                        believe Bell Hill will not be able to stay secret for much very longer.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BellHillVineyards",
    data() {
        return {
            select: {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Bell Hill Vineyards | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the premium wines from Bell Hill Vineyards, a leading wine producer in New Zealand. Experience the unique blend of traditional winemaking techniques and modern innovation in every sip. Enjoy the best of New Zealand\'s wine country with Bell Hill Vineyards.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
